module.exports = __webpack_public_path__ + "static/media/rg-2-250x251.60f19f7b.png";